export const SIGNUP_MESSAGES = {
  // 공통 메시지
  DUPLICATE_CHECK_REQUIRED: '아이디 중복확인을 해주세요.',
  GUARDIAN_INFO_REQUIRED: '보호자 정보를 입력해주세요.',
  GUARDIAN_PHONE_AUTH_REQUIRED: '보호자 전화번호를 인증받아 주세요',
  SIGNUP_FAILED: '가입에 실패하였습니다. 다시 시도해주세요.',
  CANCEL_CONFIRM:
    '회원가입을 취소하시겠습니까?\n 입력하신 정보는 모두 삭제됩니다.',

  // 아이디 관련. 형식 오류 메시지는 constants/validation 의 uidRules 에서 만든다.
  UID_REQUIRED: '아이디를 입력해주세요.',
  UID_PATTERN_INVALID: '아이디 형식이 올바르지 않습니다.',
  UID_AVAILABLE: '사용 가능한 아이디입니다.',
  UID_DUPLICATE: '이미 사용중인 아이디입니다.',
  UID_CHECK_FAILED: '아이디 중복확인에 실패하였습니다. 다시 시도해주세요.',

  // 이메일 관련
  EMAIL_REQUIRED: '이메일을 입력해주세요.',

  // 비밀번호 관련
  PASSWORD_REQUIRED: '비밀번호를 입력해주세요.',
  PASSWORD_CONFIRM_REQUIRED: '비밀번호 확인을 입력해주세요.',
  PASSWORD_NOT_MATCH: '비밀번호가 일치하지 않습니다.',

  // 이름 관련 메시지는 constants/validation 의 nameRules 에서 만든다.

  // 생년월일 관련
  BIRTHDAY_REQUIRED: '생년월일을 입력해주세요.',

  // 성별 관련
  GENDER_REQUIRED: '성별을 선택해주세요.',
} as const;

export const SIGNUP_PLACEHOLDERS = {
  PHONE: '전화번호',
  UID: '아이디',
  EMAIL: 'email',
  PASSWORD: '비밀번호',
  PASSWORD_CONFIRM: '비밀번호 확인',
  NAME: '이름',
} as const;

export const SIGNUP_LABELS = {
  PHONE: '전화번호',
  TITLE: '가입 정보 입력',
} as const;

export const SIGNUP_BUTTONS = {
  DUPLICATE_CHECK: '중복확인',
  SIGNUP: '가입하기',
  SIGNUP_IN_PROGRESS: '가입중...',
  CANCEL: '취소',
  CONTINUE_SIGNUP: '계속 가입하기',
  CANCEL_SIGNUP: '가입 취소하기',
} as const;
